<template>
  <IdentificationFormContainer
    @transfer="(data)=>$emit('transfer',data)"
    @lockFwdBtn="(value)=>$emit('lockFwdBtn',value)"
    :income="income"
    :document="formData.document ? formData.document : null"
    ref="identificationFormContainer"
  ></IdentificationFormContainer>
</template>

<script>
    import IdentificationFormContainer from "../components/IdentificationFormContainerAgreementConclusion";

    export default {
        props: ['income', 'formData'],
        components: {
            IdentificationFormContainer
        },
        methods: {
            transferData() {
                return this.$refs.identificationFormContainer.transferData()
            }
        }
    }
</script>
